export const LOCKS = {
    DOMAIN_LOCK: "DOMAIN_LOCK",
    CONTRACT_LOCK: "CONTRACT_LOCK",
    USER_LOCK: "USER_LOCK",
};

export const LOCK_TABS = {
    [LOCKS.DOMAIN_LOCK]: 0,
    [LOCKS.CONTRACT_LOCK]: 1,
    [LOCKS.USER_LOCK]: 2,
};
